// frontend/modules/document-type/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { DocumentTypeManagementView } from './views/DocumentTypeManagementView';
import { DocumentTypeCreateView } from './views/DocumentTypeCreateView';
import { DocumentTypeEditView } from './views/DocumentTypeEditView';
import { DocumentTypeDetailView } from './views/DocumentTypeDetailView';

export const documentTypeRoutes: RouteObject[] = [
    {
        path: '/admin/document-types',
        errorElement: <ErrorBoundary />,
        children: [
            {
                path: 'management',
                element: <DocumentTypeManagementView />,
            },
            {
                path: 'create',
                element: <DocumentTypeCreateView />,
            },
            {
                path: 'edit/:code',
                element: <DocumentTypeEditView />,
            },
            {
                path: 'view/:code',
                element: <DocumentTypeDetailView />,
            }
        ]
    }
];
